// For the Citi statement CSV
export interface CitiTransaction {
  Status: string;
  Date: string;
  Description: string;
  Debit: string;
  Credit: string;
  // Optional Excel-specific fields
  Category?: string;
  ExpenseCOGS?: string;
}

// For the processed expense report
export interface ExpenseEntry {
  date: string;
  description: string;
  amount: number;
  category: string;
  expenseCOGS: string; // Adding required field for Expense/COGS classification
  notes: string;
  month?: string; // Month extracted from date for pivot table grouping
  tags?: string[];
  taxDeductible?: boolean;
}

// Business categories options (from Excel Category sheet)
// These categories are more specific than general categories
export const BUSINESS_CATEGORIES = [
  'Software Expense',
  'Office Expense',
  'Facebook',
  'LinkedIn',
  'Google',
  'Paid SM COGS',
  'Travel Expense',
  'Recruiting Expense',
  'Insurance',
  'Food & Entertainment',
  'Bank Fees',
  'Legal & Professional Fees',
  'Graphic Design',
  'Shipping',
  'Marketing Expense',
  'Promotional',
  'Freelance',
  'Consulting Fees',
  'Web Hosting'
];

// General expense categories (for UI organization)
export const EXPENSE_CATEGORIES = [
  'Advertising',
  'Business Services',
  'Entertainment',
  'Food & Dining',
  'Merchandise',
  'Office Supplies',
  'Payment',
  'Professional Services',
  'Rent',
  'Software',
  'Subscriptions',
  'Technology',
  'Telecommunications',
  'Travel',
  'Transportation',
  'Utilities',
  'Other'
];

// Expense/COGS types for categorizing business expenses
export const EXPENSE_COGS_TYPES = [
  // Expense Types
  'Software Expense',
  'Office Expense',
  'Hardware Expense',
  'Accounting Expense',
  'Legal Expense',
  'Airfare Expense',
  'Hotel Expense',
  'Local Transportation Expense',
  'OOT Travel Expense',
  'Meals Expense',
  'Car Insurance Expense',
  'Cable & Internet Expense',
  'Rent Expense',
  'Telephone Expense',
  'Postage & Delivery Expense',
  'Dues and Subscriptions',
  'Professional Development Expense',
  'Recruiting Expense',
  'Bank Service Charge Expense',
  'Research & Development Expense',
  'Business Gifts Expense',
  'Business Development Expense',
  'Advertising and Promotion',
  'Production Expense',
  // COGS Types
  'SM COGS',
  'Hosting COGS',
  'SM Production COGS',
  'Website Maintenance COGS',
  'Website Project COGS',
  'Paid SM COGS',
  'Paid Media COGS',
  'SEO COGS',
  'Freelance COGS'
];

// Rule match types
export enum RuleMatchType {
  CONTAINS = 'contains',
  EXACT = 'exact',
  STARTS_WITH = 'startsWith',
  ENDS_WITH = 'endsWith',
  REGEX = 'regex'
}

// Rule match display names
export const RULE_MATCH_TYPE_LABELS = {
  [RuleMatchType.CONTAINS]: 'Contains',
  [RuleMatchType.EXACT]: 'Exact Match',
  [RuleMatchType.STARTS_WITH]: 'Starts With',
  [RuleMatchType.ENDS_WITH]: 'Ends With',
  [RuleMatchType.REGEX]: 'Regular Expression'
};

// For storing category rules
export interface CategoryRule {
  pattern: string;
  category: string;
  expenseCOGS?: string; // Adding optional Expense/COGS classification
  matchType?: RuleMatchType;
  caseSensitive?: boolean;
}

// Budget item interface
export interface BudgetItem {
  category: string;
  amount: number;
} 